<div class="main_div">
  <div class="mb-4">
    <span class="details_div" style="color: #0054a6"> Csr-donation / </span
    ><span class="details_div" style="color: black">Csr-campaigns</span>
  </div>

  <div class="header">
    <div class="header_text">
      <div class="donation_camp_text">Campaigns</div>
    </div>
  </div>

  <!-- panel-title -->
  <div class="full_panel row">
    <div class="col-sm-12 col-lg-6 tab_div">
      <!-- *ngIf="sessionUser?.role?.short_form === 'system_admin'" -->
      <div class="tab" [class.active]="activeTab === 1" (click)="activeTab = 1">
        <img
          [src]="
            activeTab === 1
              ? './assets/images/icon/dashboard_icon_active.svg'
              : './assets/images/icon/dashboard_icon_inactive.svg'
          "
        />
        {{ selectedRole?.short_form === "system_admin" ? "All" : "Matched" }}
      </div>
      <div class="tab" [class.active]="activeTab === 2" (click)="activeTab = 2">
        <img
          [src]="
            activeTab === 2
              ? './assets/images/icon/info_active_icon.svg'
              : './assets/images/icon/info_inactive_icon.svg'
          "
        />
        {{
          selectedRole?.short_form === "system_admin" ? "Tagged" : "Not Matched"
        }}
      </div>
    </div>

    <div class="col-sm-12 col-lg-6 panel_right_side">
      <dx-text-box
        class="search_box"
        placeholder="Find Campaign"
        [showClearButton]="true"
        [(ngModel)]="searchText"
        [buttons]="[
          {
            name: 'searchCampaign',
            location: 'before',
            options: {
              icon: 'find',
              elementAttr: {
                class: 'searchForm'
              }
            }
          }
        ]"
      >
      </dx-text-box>
    </div>
  </div>
  <!-- panel-title-end -->

  <!-- tab-panel-content -->

  @if (activeTab === 1 && selectedRole?.short_form === 'system_admin') {
  <div class="panel_content_for_my_campaign">
    <div class="ngo_list">
      <div
        class="ngo_card"
        *ngFor="
          let ngo of campaignList
            | filter
              : searchText
              : ['ngo_name', 'title', 'subtitle', 'description'];
          let i = index
        "
      >
        <div class="card_1st_div">
          <div class="logo_div cursor">
            <img [src]="ngo?.cover_img_vdo?.url" alt="Not Available" />
          </div>
          <div class="card_2st_div">
            <div class="card_2st_div cursor" (click)="goToCampaignDetails(ngo)">
              <div class="title">
                <div class="subtitle">{{ ngo?.ngo_name }}</div>
              </div>
              <div class="title">
                {{ ngo?.title }}
                <img [src]="'/assets/images/icon/verified_icon_green.svg'" />
              </div>
              <div class="address_div">
                <div>
                  {{ ngo?.subtitle || "Not Available!" }}
                </div>
              </div>
              <div class="details_div">{{ ngo?.description }}</div>
            </div>
            <div class="butons" style="display: flex; gap: 16px">
              <dx-button
                class="blue-button-md"
                (click)="goToCampaignDetails(ngo)"
                >View Details</dx-button
              >
              @if( selectedRole?.short_form === 'system_admin') {
              <div class="buttons organizer_inf" *ngIf="activeTab === 1">
                <span
                  [id]="'donate-button-wrapper-' + i"
                  class="button-wrapper"
                >
                  <!-- [disabled]="ngo?.is_csr_allowed" -->
                  <dx-button
                    *ngIf="!ngo?.is_csr_allowed"
                    class="blue-button-md cursor"
                    (click)="tagCsr(ngo)"
                  >
                    Tag To CSR
                  </dx-button>
                  <dx-tooltip
                    *ngIf="ngo?.is_csr_allowed"
                    [target]="'#donate-button-wrapper-' + i"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    showMode="onHover"
                    position="top"
                  >
                    <div>This Campaign or Campaigns NGO has been tagged</div>
                  </dx-tooltip>
                </span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="direction-button" style="margin-inline: auto">
        <dx-button
          class="blue-button-md"
          (click)="getAllCampaigns(page + 1, 3)"
          [disabled]="isShowMoreDisabled"
          >Load More</dx-button
        >
      </div>
    </div>
    <div
      *ngIf="campaignList?.length === 0"
      class="No_form_container d-flex flex-column align-items-center"
      style="margin-top: 50px"
    >
      <img
        src="./assets/images/icon/donation_colorful_icon.svg"
        alt="donation-image"
        title="donations"
      />
      <span class="no_form_workspace">Not Available</span>
    </div>
  </div>
  } @else if(activeTab === 1 && selectedRole?.short_form ===
  'corporate_employee') {
  <div class="panel_content_for_my_campaign">
    <div class="ngo_list">
      <div
        class="ngo_card"
        *ngFor="
          let ngo of csrMatchedCampaignList
            | filter
              : searchText
              : ['ngo_name', 'title', 'subtitle', 'description'];
          let i = index
        "
      >
        <div class="card_1st_div">
          <div class="logo_div cursor" (click)="goToCampaignDetails(ngo)">
            <img
              [src]="
                selectedRole?.short_form === 'system_admin'
                  ? ngo?.cover_img_vdo?.url
                  : ngo.cover_img_vdo ||
                    './assets/images/icon/donation_colorful_icon.svg'
              "
              alt="Not Available"
            />
          </div>
          <div class="card_2st_div">
            <div class="cursor" (click)="goToCampaignDetails(ngo)">
              <div class="title">
                <div class="subtitle">{{ ngo?.ngo_name }}</div>
              </div>
              <div class="title">
                {{ ngo?.title }}
                <img [src]="'/assets/images/icon/verified_icon_green.svg'" />
              </div>
              <div class="address_div">
                <div>
                  {{ ngo?.subtitle || "Not Available!" }}
                </div>
              </div>
              <div class="details_div">{{ ngo?.description }}</div>
            </div>
            @if( selectedRole?.short_form === 'corporate_employee' ) {
            <div class="status_div" *ngIf="ngo?.has_matching">
              <div>
                <dx-progress-bar
                  class="progress"
                  [min]="0"
                  [max]="ngo?.matching_budget"
                  [value]="ngo?.matching_amount"
                  [showStatus]="false"
                  [hint]="
                    (ngo?.matching_amount / ngo?.matching_budget) * 100 + '%'
                  "
                ></dx-progress-bar>
              </div>
              <div class="donation_count">
                <span class="fw-bolder">
                  Matched - ৳
                  {{ ngo?.matching_amount | number }}
                </span>

                <span> Budget - ৳ {{ ngo?.matching_budget | number }} </span>
              </div>
              <div class="donation_count">
                <span>
                  Allowed % -
                  {{ ngo?.matching_percentage | number : "1.1-1" }}%
                </span>

                <span>
                  Limit - ৳
                  {{ ngo?.matching_limit | number }}
                </span>
              </div>
            </div>
            <div class="warnign" *ngIf="!ngo?.has_matching">
              No Matching Is confirmed By Admin
            </div>
            } @if(selectedRole?.short_form === 'corporate_employee'){
            <div class="buttons">
              <button class="blue-button-md" (click)="goToCampaignDetails(ngo)">
                View Campaign
              </button>
              <button class="blue-button-md" (click)="donationPopupOpen(ngo)">
                Donate Now
              </button>
            </div>
            }
          </div>
        </div>
      </div>
      <div
        *ngIf="csrMatchedCampaignList?.length === 0"
        class="No_form_container d-flex flex-column align-items-center"
        style="margin-top: 50px"
      >
        <img
          src="./assets/images/icon/donation_colorful_icon.svg"
          alt="donation-image"
          title="donations"
        />
        <span class="no_form_workspace">No Matched Campaign is available</span>
      </div>
    </div>
  </div>
  } @if(activeTab === 2 && selectedRole?.short_form === 'system_admin') {
  <div class="panel_content_for_my_campaign">
    <div class="ngo_list">
      <div
        class="ngo_card"
        *ngFor="
          let ngo of activeDataSource
            | filter
              : searchText
              : ['ngo_name', 'title', 'subtitle', 'description'];
          let i = index
        "
      >
        <div class="card_1st_div">
          <div class="logo_div cursor" (click)="goToCampaignDetails(ngo)">
            <img
              [src]="
                selectedRole?.short_form === 'system_admin'
                  ? ngo?.cover_img_vdo?.url
                  : ngo.cover_img_vdo ||
                    './assets/images/icon/donation_colorful_icon.svg'
              "
              alt="Not Available"
            />
          </div>
          <div class="card_2st_div">
            <div class="cursor" (click)="goToCampaignDetails(ngo)">
              <div class="title">
                <div class="subtitle">{{ ngo?.ngo_name }}</div>
              </div>
              <div class="title">
                {{ ngo?.title }}
                <img [src]="'/assets/images/icon/verified_icon_green.svg'" />
              </div>
              <div class="address_div">
                <div>
                  {{ ngo?.subtitle || "Not Available!" }}
                </div>
              </div>
              <div class="details_div">{{ ngo?.description }}</div>
            </div>
            @if(selectedRole?.short_form === 'system_admin' ) {
            <dx-button
              [disabled]="!ngo?.is_csr_allowed"
              class="yellow-button-md"
              (click)="untagCsr(ngo)"
            >
              {{ ngo?.is_csr_allowed ? "Untag" : "Re-Tag" }}
            </dx-button>
            } @if(selectedRole?.short_form === 'corporate_employee' ) {
            <div class="status_div" *ngIf="ngo?.has_matching">
              <div>
                <dx-progress-bar
                  class="progress"
                  [min]="0"
                  [max]="ngo?.matching_budget"
                  [value]="ngo?.matching_amount"
                  [showStatus]="false"
                  [hint]="
                    (ngo?.matching_amount / ngo?.matching_budget) * 100 + '%'
                  "
                ></dx-progress-bar>
              </div>
              <div class="donation_count">
                <span class="fw-bolder">
                  Matched - ৳
                  {{ ngo?.matching_amount | number }}
                </span>

                <span> Budget - ৳ {{ ngo?.matching_budget | number }} </span>
              </div>
              <div class="donation_count">
                <span>
                  Allowed % -
                  {{ ngo?.matching_percentage | number : "1.1-1" }}%
                </span>

                <span>
                  Limit - ৳
                  {{ ngo?.matching_limit | number }}
                </span>
              </div>
            </div>
            <div class="warnign" *ngIf="!ngo?.has_matching">
              No Matching Is confirmed By Admin
            </div>
            } @if(selectedRole?.short_form === 'corporate_employee'){
            <div class="buttons">
              <!-- <button class="blue-button-md" (click)="goToCampaignDetails(ngo)">
                View Campaign
              </button> -->
              <button class="blue-button-md" (click)="donationPopupOpen(ngo)">
                Donate Now
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="activeDataSource?.length === 0"
      class="No_form_container d-flex flex-column align-items-center"
      style="margin-top: 50px"
    >
      <img
        src="./assets/images/icon/donation_colorful_icon.svg"
        alt="donation-image"
        title="donations"
      />
      <span class="no_form_workspace">No Tagged List is available</span>
    </div>
  </div>
  }@else if(activeTab === 2 && selectedRole?.short_form ===
  'corporate_employee') {
  <div class="panel_content_for_my_campaign">
    <div class="ngo_list">
      <div
        class="ngo_card"
        *ngFor="
          let ngo of csrNotMatchedCampaignList
            | filter
              : searchText
              : ['ngo_name', 'title', 'subtitle', 'description'];
          let i = index
        "
      >
        <div class="card_1st_div">
          <div class="logo_div cursor" (click)="goToCampaignDetails(ngo)">
            <img
              [src]="
                selectedRole?.short_form === 'system_admin'
                  ? ngo?.cover_img_vdo?.url
                  : ngo.cover_img_vdo ||
                    './assets/images/icon/donation_colorful_icon.svg'
              "
              alt="Not Available"
            />
          </div>
          <div class="card_2st_div">
            <div class="cursor" (click)="goToCampaignDetails(ngo)">
              <div class="title">
                <div class="subtitle">{{ ngo?.ngo_name }}</div>
              </div>
              <div class="title">
                {{ ngo?.title }}
                <img [src]="'/assets/images/icon/verified_icon_green.svg'" />
              </div>
              <div class="address_div">
                <div>
                  {{ ngo?.subtitle || "Not Available!" }}
                </div>
              </div>
              <div class="details_div">{{ ngo?.description }}</div>
            </div>
            @if(selectedRole?.short_form === 'corporate_employee' ) {
            <div class="status_div" *ngIf="ngo?.has_matching">
              <div>
                <dx-progress-bar
                  class="progress"
                  [min]="0"
                  [max]="ngo?.matching_budget"
                  [value]="ngo?.matching_amount"
                  [showStatus]="false"
                  [hint]="
                    (ngo?.matching_amount / ngo?.matching_budget) * 100 + '%'
                  "
                ></dx-progress-bar>
              </div>
              <div class="donation_count">
                <span class="fw-bolder">
                  Matched - ৳
                  {{ ngo?.matching_amount | number }}
                </span>

                <span> Budget - ৳ {{ ngo?.matching_budget | number }} </span>
              </div>
              <div class="donation_count">
                <span>
                  Allowed % -
                  {{ ngo?.matching_percentage | number : "1.1-1" }}%
                </span>

                <span>
                  Limit - ৳
                  {{ ngo?.matching_limit | number }}
                </span>
              </div>
            </div>
            <div class="warnign" *ngIf="!ngo?.has_matching">
              No Matching Is confirmed By Admin
            </div>
            } @if(selectedRole?.short_form === 'corporate_employee'){
            <div class="buttons">
              <button class="blue-button-md" (click)="goToCampaignDetails(ngo)">
                View Campaign
              </button>
              <button class="blue-button-md" (click)="donationPopupOpen(ngo)">
                Donate Now
              </button>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="csrNotMatchedCampaignList?.length === 0"
      class="No_form_container d-flex flex-column align-items-center"
      style="margin-top: 50px"
    >
      <img
        src="./assets/images/icon/donation_colorful_icon.svg"
        alt="donation-image"
        title="donations"
      />
      <span class="no_form_workspace">Not available</span>
    </div>
  </div>
  }
</div>

<dx-popup
  [width]="'50vw'"
  [(visible)]="donationPopup"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="false"
>
  <div class="left_side_">
    <div
      class="cross_button_div_"
      style="margin-right: 20px; text-align: right; width: 100%"
    >
      <button class="cross_button" (click)="hide()">
        <img
          src="./assets/images/icon/x-circle.svg"
          alt="cross"
          loading="lazy"
          title="close"
        />
      </button>
    </div>
    <div class="transaction_fees_title">Make Your Contribution</div>
    <div class="left_total_donation">
      <div class="enter_donation_amount requiredMark">Donation Amount</div>
      <div class="suggested_all_amount p-2">
        <div
          class="amount_"
          *ngFor="let fund of suggestedFund; let i = index"
          [class.selected]="fund?.isSelected"
          (click)="selectAmount(i)"
        >
          {{ fund.amount | number }}
        </div>
      </div>
      <div class="total_amount">
        <div>৳</div>
        <dx-number-box
          class="amount_tk"
          placeholder=""
          [invalidValueMessage]="'Value must be a number'"
          [format]="',##0'"
          [valueChangeEvent]="'input'"
          [min]="0"
          [(ngModel)]="selectedAmount"
        >
          <dx-validator validationGroup="validationGrp">
            <dxi-validation-rule
              type="required"
              message="Target amount is required"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="range"
              [min]="10"
              message="Minimum amount 10 tk"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-number-box>
      </div>
    </div>

    <div class="donation_details_">
      <div class="donation_amount_transaction_fees">
        <div class="donation_amount">
          <div class="donation_name">Donation</div>
          <div class="donation_number">
            ৳
            {{
              coverFees
                ? (selectedAmount | number)
                : (selectedAmount - selectedAmount * 0.14 | number)
            }}
          </div>
        </div>
        <div class="donation_amount">
          <div class="transaction_fees_title">Total transaction fees</div>
          <div class="transaction_amount">
            ৳ {{ selectedAmount * 0.14 | number }}
          </div>
        </div>
        <div class="_100_of_your">
          100% of your donation goes to {{ campaignTitle }}
        </div>
      </div>
      <div class="donation_inf">
        <div class="_100_of_your">
          Transaction fees cover disbursement and donation reporting.
        </div>
        <div class="confirmation">
          <p class="cursor">
            <dx-check-box
              [elementAttr]="{ 'aria-label': 'Checked' }"
              class="checkbox"
              text="I’ll cover the transaction fee"
              [(ngModel)]="coverFees"
            >
            </dx-check-box>
          </p>
        </div>
      </div>
      <div class="form-group">
        <div class="input_div">
          <label class="field-label requiredMark">Upload Payment Receipt</label>
          <div
            class="file-upload-container"
            (drop)="onDropSuccess($event)"
            (dragover)="onDragOver($event)"
          >
            <label class="w-100">
              <dx-text-box
                class="uploader_input_field w-100"
                placeholder="Drag and drop files here or browse file"
                [ngModel]="receiptName"
                [readOnly]="true"
                [showClearButton]="false"
              >
                <dx-validator validationGroup="validationGrp">
                  <dxi-validation-rule
                    type="required"
                    message="Receipt is required."
                  >
                  </dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
              <input
                #ngoLogoInput
                type="file"
                class="box-file"
                id="donationReceipt"
                (change)="onFileChange($event)"
                aria-hidden="true"
                accept=".jpg, .jpeg, .png, .pdf"
                [multiple]="false"
              />
            </label>
            <div
              class="blue-button-md"
              type="button"
              (click)="triggerFileInput('donationReceipt')"
            >
              Browse File
            </div>
          </div>
          <div class="field_footer_label" style="margin-top: 16px">
            Find your receipt in: SMS, banking app, or email confirmation.
          </div>
          <div class="mapping_div" style="margin-top: 16px">
            <label class="field_label" style="margin-bottom: 8px"
              >Request Matching Percentage</label
            >
            <dx-number-box
              class="input_field"
              [(ngModel)]="mapRequest"
              [value]="matchedAmount"
              [readOnly]="matchedAmount ? true : false"
              placeholder="Matching Percentage"
              [showClearButton]="true"
              format="#,##0'%'"
              [invalidValueMessage]="'Value must be a number'"
              [min]="0"
            >
              <dx-validator
                [validationGroup]="
                  hasMatched ? 'validationGrp2' : 'validationGrp'
                "
              >
              </dx-validator>
            </dx-number-box>
          </div>
        </div>
      </div>
      <div class="innet_pop_total_">
        <div class="donation_name">Total Amount</div>
        <div class="transaction_amount">
          ৳
          {{
            coverFees
              ? (selectedAmount + selectedAmount * 0.14 | number)
              : (selectedAmount | number)
          }}
        </div>
      </div>
    </div>
    <div class="_100_of_your text-dark">
      On your Contribution company will match
    </div>
    <div class="donate_payment">
      <div class="pay_buttons">
        <div
          (click)="donate()"
          class="blue-button-lg fw-bold cursor w-100"
          style="text-align: center"
        >
          Donate Now
        </div>
      </div>
    </div>
  </div>
</dx-popup>

<dx-popup
  [(visible)]="openThankYouPopup"
  [height]="'auto'"
  [width]="'70vw'"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
>
  <div class="root">
    <div class="bookmarks">
      <img
        class="icons8-no-bookmark-100-1"
        loading="lazy"
        alt=""
        src="../../../../assets/images/icon/right-green.svg"
      />
    </div>
    <section class="you-havent-bookmarked">
      Thank You for Your Contribution {{ sessionUser.name }}
    </section>
    <div class="feedback">
      You have successfully donated ৳
      {{ externalCsrDonationCampaignModel?.pledged_amount | number }} to “{{
        campaignTitle
      }}”
    </div>
    <div class="feedback">
      A receipt has been sent to your email: {{ sessionUser?.email }}.
    </div>
  </div>
</dx-popup>
